module.exports = __webpack_public_path__ + "img/icon-1.02a84b15.png";